export default "__VITE_ASSET__CD7ueTd0__"